import React from 'react';
import PropTypes from 'prop-types'

// Redux
import { connect } from 'react-redux';

// Actions
import { toggleSideNav } from '../../actions/navActions';

// Components
import Logo from '../common/Logo_Round';

// Icons
import MenuOutlinedIcon from '@mui/icons-material/MenuOutlined';
  
const Help_Navbar = ({
    toggleSideNav
}) =>  {

    return (
      <div style={{zIndex: 50, /*position: 'fixed',*/ paddingTop: '8px', paddingLeft: '0', paddingRight: '0', display: 'flex', justifyContent: 'center', width: '100%'}}>
        <div style={{height: '4rem', width: '100%', paddingLeft: '1.5rem', paddingRight: '1.5rem', display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
            {/* Logo Container */}
            <div onClick={() => window.location = '/'} style={{gap: '.5rem', display: 'flex', alignItems: 'center', cursor: 'pointer'}}>
                {/* Img - Logo */}
                <img alt="Interview Cheater" loading="lazy" width="20" height="20" decoding="async" src={Logo} style={{borderRadius: '50%', width: '1.25rem', height: '1.25rem'}} />
                {/* Text - Logo */}
                <span style={{fontWeight: 600, fontSize: '.875rem', lineHeight: '1.25rem'}}>
                    Interview Cheater
                </span>
            </div>

            <div className="menu_btn" onClick={() => toggleSideNav()}>
                <MenuOutlinedIcon />
            </div>
        </div>
      </div>
    );
}
  
Help_Navbar.propTypes = {
    toggleSideNav: PropTypes.func.isRequired,
}

const mapStateToProps = state => ({
})

export default connect(mapStateToProps, {
    
    // Connecting actions to the component
    toggleSideNav
})(Help_Navbar);
  